import { useEffect } from 'react';

import { usePerformanceActions } from 'src/store';

export const useQueryChannelAccounts = (channel, connectingToChannel) => {
  const performanceActions = usePerformanceActions();

  useEffect(() => {
    if (connectingToChannel || !channel) {
      return;
    }

    performanceActions.queryConnectedChannelAccounts(channel);
  }, [connectingToChannel, performanceActions, channel]);
};
